
import {DigitizationCategories, DigitizationTools} from "../ToolRegistry.js";
import {totalPolylineLength, offsetPointAlongPolyline, labelOffsetDistance, polygonArea, polygonPerimeter} from "../geometry/measurementGeometry.js";
import {formatLength} from "./distanceTool.js";
import {formatArea, averagePosition, FILL_COLOR, FILL_OPACITY} from "./areaTool.js";

import {t, T} from "../i18n/index.js";
DigitizationCategories.register({id: "basic", name: T("Grundlæggende geometri"), order: 0});
DigitizationCategories.register({id: "calculated", name: T("Beregnet geometri"), order: 1});
DigitizationCategories.register({id: "specialized", name: T("Specialiseret registrering"), order: 2});

export const PointTool = {
	id: "digitize_point",
	name: T("Punkt"),
	category: "basic",
	kind: "registration",
	toolbarGroup: "registration",
	toolbarOrder: 10,
	icon: "digitize_point.svg",
	resultGeometryType: "Point",
	maxPoints: 1,
	tooltip: T("Opret et 3D-punkt ved at vælge en position i punktskyen."),
	instructions: T("Venstreklik på punktskyen for at placere punktet."),
};

export const LineTool = {
	id: "digitize_line",
	name: T("Linje"),
	category: "basic",
	kind: "registration",
	toolbarGroup: "registration",
	toolbarOrder: 20,
	icon: "digitize_line.svg",
	resultGeometryType: "LineString",
	maxPoints: Infinity,
	tooltip: T("Digitalisér en 3D-linje gennem to eller flere valgte punkter."),
	instructions: T("Venstreklik for at placere linjens punkter. Højreklik for at afslutte linjen."),

	// User-requested: show the total length, same as Mål afstand's own
	// summary label mechanism - but unlike Mål afstand, vertex labels and
	// per-segment length labels stay on (not requested for this tool).
	summaryLabelFormat(raw, visual){
		if(raw.length < 2) return null;
		return [visual.name, t("Samlet længde: {0}", formatLength(totalPolylineLength(raw)))];
	},
	// User-requested fix: anchored at the last vertex, the label used to sit
	// directly on top of that vertex's own coordinate label. Moved to the
	// line's own midpoint (by path length, not a straight endpoint average -
	// see measurementGeometry.js's pointAlongPolyline()), offset sideways by
	// a modest fraction of the line's own length so it clears the line
	// itself (offsetPointAlongPolyline()/labelOffsetDistance()).
	summaryLabelAnchor(raw){
		const offset = offsetPointAlongPolyline(raw, 0.5, labelOffsetDistance(totalPolylineLength(raw)));
		return {x: offset[0], y: offset[1], z: offset[2]};
	},
};

export const PolygonTool = {
	id: "digitize_polygon",
	name: T("Polygon"),
	category: "basic",
	kind: "registration",
	toolbarGroup: "registration",
	toolbarOrder: 30,
	icon: "digitize_polygon.svg",
	resultGeometryType: "Polygon",
	maxPoints: Infinity,
	tooltip: T("Digitalisér et lukket 3D-polygon gennem tre eller flere valgte punkter."),
	instructions: T("Venstreklik for at placere polygonens punkter. Højreklik for at afslutte og lukke polygonen."),

	// User-requested: semi-transparent green fill (same convention as Mål
	// areal - see areaTool.js's FILL_COLOR) and a summary label with area
	// and perimeter - vertex labels and per-segment labels stay on (not
	// requested for this tool, unlike Mål areal).
	fillColor: FILL_COLOR,
	fillOpacity: FILL_OPACITY,
	summaryLabelFormat(raw, visual){
		if(raw.length < 3) return null;
		return [
			visual.name,
			t("Areal: {0}", formatArea(polygonArea(raw))),
			t("Omkreds: {0}", formatLength(polygonPerimeter(raw))),
		];
	},
	summaryLabelAnchor(raw){
		return averagePosition(raw);
	},
};

DigitizationTools.register(PointTool);
DigitizationTools.register(LineTool);
DigitizationTools.register(PolygonTool);
